import type { Role } from '@/api/types'

/**
 * Frontend RBAC mirrors the backend role sets so the UI hides what the server
 * would reject. The server remains the source of truth — this is UX, not security.
 */

/** Create/edit orders, route templates, etc. */
export const MANAGER_ROLES: readonly Role[] = [
  'ADMIN',
  'OWNER',
  'PRODUCTION_MANAGER',
  'SALES_MANAGER',
]

/** Order lifecycle control (launch/pause/ship/...) and route management. */
export const CONTROL_ROLES: readonly Role[] = ['ADMIN', 'OWNER', 'PRODUCTION_MANAGER']

/** Dashboards / analytics are management-only. */
export const MANAGEMENT_ROLES: readonly Role[] = ['ADMIN', 'OWNER', 'PRODUCTION_MANAGER']

export function isAdmin(role: Role): boolean {
  return role === 'ADMIN'
}
export function isManager(role: Role): boolean {
  return MANAGER_ROLES.includes(role)
}
export function isControl(role: Role): boolean {
  return CONTROL_ROLES.includes(role)
}
export function isManagement(role: Role): boolean {
  return MANAGEMENT_ROLES.includes(role)
}

export type Capability =
  | 'orders.manage'
  | 'orders.control'
  | 'routes.manage'
  | 'dashboard.view'
  | 'admin.users'
  | 'admin.delayreasons'

export function can(role: Role, capability: Capability): boolean {
  switch (capability) {
    case 'orders.manage':
      return isManager(role)
    case 'orders.control':
    case 'routes.manage':
      return isControl(role)
    case 'dashboard.view':
      return isManagement(role)
    case 'admin.users':
    case 'admin.delayreasons':
      return isAdmin(role)
  }
}
